import script from "./afterSale.vue?vue&type=script&setup=true&lang=js"
export * from "./afterSale.vue?vue&type=script&setup=true&lang=js"

import "./afterSale.vue?vue&type=style&index=0&id=10b78152&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b78152"]])

export default __exports__